import { z } from 'zod';
import { I18nStringSchema } from '../../core/i18n';
const FootprintStyleSchema = z.object({
    color: z.string(),
    lineColor: z.string(),
    draggingOpacity: z.number().min(0).max(1),
    placedOpacity: z.number().min(0).max(1),
    selectedOpacity: z.number().min(0).max(1)
});
const PillColorSchema = z.object({
    bgColor: z.string(),
    textColor: z.string()
});
export const RemedyCategorySchema = z.object({
    id: z.string(),
    name: I18nStringSchema,
    categoryColor: z.string(),
    sortOrder: z.number(),
    pillColors: z.object({
        light: PillColorSchema,
        satellite: PillColorSchema
    }),
    footprintStyles: z.object({
        light: FootprintStyleSchema,
        satellite: FootprintStyleSchema
    })
});
//# sourceMappingURL=remedyCategory.js.map